<script setup lang="ts">
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useI18n } from 'vue-i18n'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import { watch } from 'vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
}>()

// Validation: one of the two must be chosen
const rules = {
  umsokn: {
    takeOverLoan: { required }
  }
}

const v$ = useVuelidate(rules, { umsokn })

function validate() {
  v$.value.$touch()
  return !v$.value.$invalid
}

// If user selects takeOverLoan, reset and add one co-debtor
watch(
  () => umsokn.value?.takeOverLoan,
  (newVal) => {
    if (newVal) {
      umsokn.value.addSamskuldari = false
      umsokn.value.coDeptors = [
        { name: '', ssn: '', phone: '', email: '' }
      ]
    }
  }
)

watch(
  () => umsokn.value?.addSamskuldari,
  (newVal) => {
    if (newVal) {
      umsokn.value.takeOverLoan = false
    }
  }
)

defineExpose({ validate })
</script>

<template>
  <div v-if="umsokn">
    <v-row>
      <v-col>
        <h2 class="form__header">
          {{ t('lan_nafnabeyting_umsokn_step2_header1') }}
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-radio-group
          v-model="umsokn.addSamskuldari"
          :readonly="props.disable"
          hide-details
        >
          <v-radio
            :label="t('lan_nafnabeyting_umsokn_step2_sjalfur_skuldari')"
            :value="true"
          />
        </v-radio-group>
      </v-col>

      <v-col cols="12">
        <v-radio-group
          v-model="umsokn.takeOverLoan"
          :readonly="props.disable"
          hide-details
        >
          <v-radio
            :label="t('lan_nafnabeyting_umsokn_step2_taka_yfir')"
            :value="true"
          />
        </v-radio-group>

        <div v-if="v$.umsokn.takeOverLoan.$error">
          <div class="error__text">
            {{ t('lan_nafnabeyting_umsokn_step2_taka_yfir_error') }}
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped lang="scss">
.forms__label {
  font-weight: bold;
  font-size: 18px;
  display: block;
  margin-bottom: 12px;
  color: #194458;
}

.forms__header {
  margin: 20px 0;
}
</style>
